"use client";

import React from "react";
import {
  CURRENCY_SYMBOL,
  CurrencyContextProps,
  CurrencyProps,
  SUPPORTED_CURRENCIES,
} from "./types";

export const DEFAULT_CURRENCY = { code: SUPPORTED_CURRENCIES.USD, symbol: CURRENCY_SYMBOL.USD };
export const DEFAULT_CONVERSION_RATE = { USD: 1 };

let CurrencyContext: React.Context<CurrencyContextProps>;
const { Provider } = (CurrencyContext = React.createContext<CurrencyContextProps>(undefined));

const CurrencyProvider = ({ children }: any) => {
  const [currency, setCurrency] = React.useState<CurrencyProps>(DEFAULT_CURRENCY);
  const [currencyConversionRates, setCurrencyConversionRates] = React.useState<{
    [key: string]: number;
  }>(DEFAULT_CONVERSION_RATE);

  const setCurrencyData = (data: CurrencyProps) => {
    setCurrency(data);
  };

  const setCurrencyConversionRatesData = (data: { [key: string]: number }) => {
    setCurrencyConversionRates(data);
  };

  return (
    <Provider
      value={{
        currency,
        setCurrency: setCurrencyData,
        currencyConversionRates,
        setCurrencyConversionRates: setCurrencyConversionRatesData,
      }}
    >
      {children}
    </Provider>
  );
};

export { CurrencyContext, CurrencyProvider };
